import React, {useEffect, useState} from 'react';
import {NavLink} from "react-router-dom";
import GraphIcon from "../../../../../../assets/GraphIcon";
import ChatIcon from "../../../../../../assets/images/chat.png";
import WebChatTest from "../../view/WebChatTest";
import config from 'config';
import {
    getClientHardcodedMessages,
    getCompanyInfo,
    updateAiDescription,
    updateHardCodedMessage,
} from "../../../../../../services/company/api";
import Translate from "../../../../../../components/Translate";
import './Configurations.css';
import EndChatsSpace from "./configurations/EndChatsSpace";
import {tabButtonStyles} from "../../../../../../utils/General";
import AIConfigs from "./configurations/AIConfigs";
import HardcodedMessagesBottomTab from "./configurations/HardcodedMessagesBottomTab";
import ForbiddenWordsConfig from "./configurations/ForbiddenWordsConfig";

const TabIds = {
    en: 10,
    it: 20,
    es: 30
};

const Configurations = ({tariff, client, user}) => {
    const {features} = tariff;
    const [showChat, setShowChat] = useState({});
    const [hardCodedMessages, setHardCodedMessages] = useState();
    const [activeTabId, setActiveTabId] = useState(TabIds.en);
    const [localeOption, setLocaleOption] = useState(config.localesOptions[0]);
    const [companyInfo, setCompanyInfo] = useState()
    const [endChatsText, setEndChatsText] = useState("");
    const [endMin, setEndMin] = useState(0);

    const [aiType, setAiType] = useState();
    const [aiContentLoadingHours, setAiContentLoadingHours] = useState();
    const [aiHumanOnlyHours, setAiHumanOnlyHours] = useState();
    const [aiDescription, setAiDescription] = useState();


    const [activeTab, setActiveTab] = useState('treeAndTest');

    useEffect(() => {
        getCompanyInfo(client.id).then((data) => {
            setCompanyInfo(data)
            setAiType(data.aiType)
            setAiDescription(data.companyDescriptionForAI)
            setAiContentLoadingHours(data.aiContentLoadingHours)
            setAiHumanOnlyHours(data.aiHumanOnlyHours)
        })
        getClientHardcodedMessages(client.id).then((data) => {
            setHardCodedMessages(data);
        });
    }, [client.id]);

    const updateHardCodedMessages = (type, locale) => {
        return text => updateHardCodedMessage(client.id, type, locale, text)
            .then(() => {
                setHardCodedMessages(prevMessages => ({
                    ...prevMessages,
                    [type]: {
                        ...prevMessages[type],
                        [locale]: text
                    }
                }));
            });
    };

    const toggleChat = (clientId) => {
        setShowChat(prevShowChat => ({
            ...prevShowChat,
            [clientId]: !prevShowChat[clientId]
        }));
    };

    const handleToggleChat = (clientId) => {
        toggleChat(clientId);
    };

    const handleAiDescriptionChange = (event) => {
        setAiDescription(event.target.value);
    };

    const handleSaveAiDescription = () => {
        updateAiDescription(client.id, aiDescription)
            .then(() => {
                setAiDescription(aiDescription);
            });
    };

    return (
        <div>

            <div style={tabButtonStyles.tabButtons}>

                {companyInfo && (
                    <React.Fragment>
                        {companyInfo.companyType === config.companyTypeMap.smart && (
                            <button style={tabButtonStyles.tabButton(activeTab === 'treeAndTest')}
                                    onClick={() => setActiveTab('treeAndTest')}>
                                <Translate text="webchatTesting"/>
                            </button>
                        )}
                        {companyInfo.companyType === config.companyTypeMap.scenario && (
                            <button style={tabButtonStyles.tabButton(activeTab === 'treeAndTest')}
                                    onClick={() => setActiveTab('treeAndTest')}>
                                <Translate text="treeAndTest"/>
                            </button>
                        )}
                    </React.Fragment>
                )}

                {features.includes(config.features.HARDCODED_MESSAGES) && (
                    <button style={tabButtonStyles.tabButton(activeTab === 'hardcodedMessages')}
                            onClick={() => setActiveTab('hardcodedMessages')}>
                        <Translate text="hardcodedMessages"/>
                    </button>
                )}

                {companyInfo && (
                    <React.Fragment>
                        {features.includes(config.features.AI) && companyInfo.companyType === config.companyTypeMap.smart && (
                            <button style={tabButtonStyles.tabButton(activeTab === 'configsAI')}
                                    onClick={() => setActiveTab('configsAI')}>
                                <Translate text="configsAI"/>
                            </button>
                        )}
                    </React.Fragment>
                )}

                {features.includes(config.features.END_UNMANAGED_CHATS) && (
                    <button style={tabButtonStyles.tabButton(activeTab === 'unmanagedChatsEndSettingHeader')}
                            onClick={() => setActiveTab('unmanagedChatsEndSettingHeader')}>
                        <Translate text="unmanagedChatsEndSettingHeader"/>
                    </button>
                )}

                {features.includes(config.features.FORBIDDEN_WORDS) && (
                    <button style={tabButtonStyles.tabButton(activeTab === 'forbiddenWords')}
                            onClick={() => setActiveTab('forbiddenWords')}>
                        <Translate text="forbiddenWords"/>
                    </button>
                )}

            </div>

            {activeTab === 'treeAndTest' && (
                <div className="bg-white">
                    <h2 className="configurations-header" style={{textAlign: 'center'}}>
                        {client.type === config.companyTypeMap.scenario && (
                            <Translate text="treeAndTest"/>
                        )}
                        {client.type === config.companyTypeMap.smart && (
                            <Translate text="webchatTesting"/>
                        )}
                    </h2>
                    <div className="configurations-main-container">
                        {client.type === config.companyTypeMap.scenario && (
                            <div className="configurations-buttonDiv">
                                <NavLink to={`/dashboard/graph/${client.id}`} className="configurations-item">
                                    <GraphIcon fill="#3D568F"
                                               style={{flexGrow: 1, flexWrap: 'wrap', width: '30px', height: '30px'}}/>
                                    <div className="configurations-tooltip"><Translate text="tree"/></div>
                                </NavLink>
                            </div>
                        )}
                        <div className="configurations-buttonDiv">
                            <div className="configurations-item" onClick={() => handleToggleChat(client.id)}>
                                <div>
                                    <img src={ChatIcon} alt="edit" width={30} height={30}/>
                                </div>
                                <div className="configurations-tooltip"><Translate text="webchatTesting"/></div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="configurations-content-container">
                {features.includes(config.features.HARDCODED_MESSAGES) && activeTab === 'hardcodedMessages' &&
                    <div className="bg-white">
                        <div className="configurations-forbidden-words-container">
                            <h2 className="configurations-header">
                                <Translate text="hardcodedMessages"/>
                            </h2>
                            {hardCodedMessages && (
                                <HardcodedMessagesBottomTab
                                    features={features}
                                    client={client}
                                    hardCodedMessages={hardCodedMessages}
                                    activeTabId={activeTabId}
                                    config={config}
                                    localeOption={localeOption}
                                    updateHardCodedMessages={updateHardCodedMessages}
                                />
                            )}
                        </div>
                    </div>
                }

                {features.includes(config.features.AI)
                    && activeTab === 'configsAI' &&
                    <div className="first-messages-block bg-white">
                        <AIConfigs
                            setAiType={setAiType}
                            aiType={aiType}
                            features={features}
                            user={user}
                            aiDescription={aiDescription}
                            handleAiDescriptionChange={handleAiDescriptionChange}
                            handleSaveAiDescription={handleSaveAiDescription}
                            client={client}
                            aiContentLoadingHours={aiContentLoadingHours}
                            setAiContentLoadingHours={setAiContentLoadingHours}
                            aiHumanOnlyHours={aiHumanOnlyHours}
                            setAiHumanOnlyHours={setAiHumanOnlyHours}
                        />
                    </div>
                }

                {features.includes(config.features.END_UNMANAGED_CHATS) && activeTab === 'unmanagedChatsEndSettingHeader' &&
                    <div className="bg-white">
                        <EndChatsSpace endMin={endMin} setEndMin={setEndMin} endChatsText={endChatsText}
                                       setEndChatsText={setEndChatsText} client={client} user={user}/>
                    </div>
                }

                {features.includes(config.features.FORBIDDEN_WORDS) && activeTab === 'forbiddenWords' &&
                    <div className="bg-white">
                        <ForbiddenWordsConfig client={client}/>
                    </div>
                }

            </div>

            {showChat[client.id] && <WebChatTest key={client.id} companyId={client.id}/>}
        </div>
    );
};

export default Configurations;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/Configurations.jsx